<template>
    <div class="widget-config-select">
        <RedesignFormLabel
            :label="templateParameterHelpName"
            :info-text="templateParameterHelpDescription"
            class="mb-2"
        />
        <RedesignBaseSelect
            v-model="componentValue"
            :collapse-tags="true"
            v-bind="parameterData"
            filterable
            multiple
            full-width
        />
    </div>
</template>

<script setup lang="ts">
import RedesignFormLabel from '@/components/RedesignBaseComponents/Form/RedesignFormLabel.vue'
import { WidgetConfig } from '@/types/dashboard'
import { computed } from 'vue'
import RedesignBaseSelect from '@/components/RedesignBaseComponents/Inputs/RedesignBaseSelect.vue'
import cloneDeep from 'lodash/cloneDeep'
import {
    getTemplateParameterHelpDescription,
    getTemplateParameterHelpName
} from '@/components/RedesignComponents/Widgets/widget.helper'

const props = defineProps<{
    value: WidgetConfig
}>()

const emit = defineEmits([ 'input', 'update:value' ])

const model = computed({
    get () {
        return props.value
    },
    set (val) {
        emit('input', val)
        emit('update:value', val)
    }
})
const templateParameterHelpName = computed(() => {
    return getTemplateParameterHelpName(props.value)
})
const templateParameterHelpDescription = computed(() => {
    return getTemplateParameterHelpDescription(props.value)
})
const componentValue = computed({
    get () {
        if (model.value.WidgetParameterJson === 1) {
            return model.value.WidgetParameterValueJson?.selected || []
        } else {
            return JSON.parse(model.value.WidgetParameterValue?.selected || '')
        }
    },
    set (val) {
        const updatedModel: Partial<WidgetConfig> = {}

        if (model.value.WidgetParameterJson === 1) {
            updatedModel.WidgetParameterValueJson = {
                ...model.value.WidgetParameterValueJson,
                selected: cloneDeep(val)
            }
        } else {
            updatedModel.WidgetParameterValue = {
                ...model.value.WidgetParameterValue,
                selected: val
            }
        }

        model.value = {
            ...model.value,
            ...updatedModel
        }
    }
})
const parameterData = computed(() => {
    const filterParameterData = model.value.ParameterData || {}

    return {
        labelKey: 'Key',
        valueKey: 'Value',
        data: filterParameterData.ItemList || [],
        ...filterParameterData
    }
})
</script>

